<template>
  <div class="p-24">
    <div class="mb-24 text-center">
      <RevIllustration
        alt=""
        class="rounded-md w-full"
        :height="240"
        src="/img/product/jp/paypay-illustration.png"
        :width="327"
      />
    </div>

    <h2 class="heading-2 mb-16">
      {{
        i18n(translations.subtitle, {
          points: i18n(translations.formattedPoints, { points }),
        })
      }}
    </h2>
    <p class="body-1 mb-24">
      {{ i18n(translations.description) }}
    </p>
    <p class="body-1 mb-16">
      {{ i18n(translations.list) }}
    </p>
    <ol class="body-1 flex flex-col gap-12">
      <li class="flex items-center gap-12">
        <div
          class="bg-static-default-mid rounded-full body-1-bold size-32 shrink-0 text-center leading-[32px]"
        >
          1
        </div>
        {{ i18n(translations.item1) }}
      </li>
      <li class="flex items-center gap-12">
        <div
          class="bg-static-default-mid rounded-full body-1-bold size-32 shrink-0 text-center leading-[32px]"
        >
          2
        </div>
        {{ i18n(translations.item2) }}
      </li>
      <li class="flex items-center gap-12">
        <div
          class="bg-static-default-mid rounded-full body-1-bold size-32 shrink-0 text-center leading-[32px]"
        >
          3
        </div>
        {{ i18n(translations.item3) }}
      </li>
    </ol>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import { calculatePaypayPoints } from '~/scopes/product-core/pages/ProductDetailPage/jp/utils/calculatePaypayPoints'

import translations from '../../PaypayModal.translations'

const props = defineProps<{ points?: number }>()

const i18n = useI18n()
const route = useRoute()

// [Apps]`points` is passed as a prop when rendered inside the drawer, but is
// derived from the `price` URL query when this body is rendered standalone as a
// webview route.
const points = computed(
  () =>
    props.points ?? calculatePaypayPoints((route.query.price as string) ?? '0'),
)
</script>
